import $ from 'jquery'

export default {
  mounted () {
    $('body').addClass('admin')
  },
  destroyed () {
    $('body').removeClass('admin')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ClasesAdmin.js